
import { Directive, HostListener, ElementRef } from '@angular/core';
import { removeHyperlinksAndSpecialChars } from '../utils/text-utils';

@Directive({
    selector: 'input:not([type="file"]), textarea'
})
export class RemoveHyperlinkDirective {
  constructor(private el: ElementRef) {}

  @HostListener('change') onChange() {
    const inputValue = this.el.nativeElement.value;
    const cleanedValue = removeHyperlinksAndSpecialChars(inputValue);
    this.el.nativeElement.value = cleanedValue;
  }

  @HostListener('input') onInput() {
    const inputValue = this.el.nativeElement.value;
    const cleanedValue = removeHyperlinksAndSpecialChars(inputValue);
    this.el.nativeElement.value = cleanedValue;
  }
  // @HostListener('textarea') onInput() {
  //   const inputValue = this.el.nativeElement.value;
  //   const cleanedValue = removeHyperlinksAndSpecialChars(inputValue);
  //   this.el.nativeElement.value = cleanedValue;
  // }
}

